module.exports = __webpack_public_path__ + "assets/img/reset_1.2143fcc2.svg";